import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";

import Modal from "react-bootstrap/Modal";
import { API_URL } from "../../components/api";
import { formatDateTime } from "../../../utils/dateFormat";
import EditOrder from "./OrderEdit";
import InvoiceOrder from "./OrderInvoice";
import QuotationOrder from "./OrderQuotation";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
} from "@mui/x-data-grid";
import './orderTable.css'
import AuthContext from "../../context/AuthContext";
import LanguageContext from "../../context/LanguageContext";

//For API Requests
import axios from "axios";

function OrderTable() {
  const [data, setData] = useState([]);
  const [showdetails, setShowDetails] = useState(false);
  const [showQuotation, setShowQuotation] = useState(false);
  const [showInvoice, setShowInvoice] = useState(false);
  const [cancelOrderId, setCancelOrderId] = useState(null);

  const [loading, setLoading] = useState(true);
  const history = useHistory();

  const handleshowDetails = () => setShowDetails(true);
  const handlecloseDetails = () => setShowDetails(false);
  const handleshowQuotations = () => setShowQuotation(true);
  const handlecloseQuotations = () => setShowQuotation(false);
  const handleshowInvoices = () => setShowInvoice(true);
  const handlecloseInvoices = () => setShowInvoice(false);
  const [message, setMessage] = useState(null);

  const [searchQuery, setSearchQuery] = useState("");
  const { user } = useContext(AuthContext);
  const { language, t } = useContext(LanguageContext);

  const [DealerDetails, setDealerDetails] = useState({
    order_id: 0,
    fullname_en: "",
    client_id: 0,
  });

  const updateDealerDetails = (details) => {
    setDealerDetails(details);
  };
  const issues = (details) => {
    setDealerDetails(details);
    history.push("/accounting/order/edit", { myProp: details.order_id });
  };
  useEffect(() => {
    let active = true;

    setLoading(true);

    const fetchData = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));

        if (language === "ar") {
          const response = await axios.get(`${API_URL}/inventory/order/`, {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
            },
            params: {
              username: user.username,
              lang: "ar",
            },
          });

          if (response.status === 200 && active) {
            setData(response.data.reverse());
            console.log(response.data);
          }

          return;
        }

        const response = await axios.get(`${API_URL}/inventory/order/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200 && active) {
          setData(response.data.reverse());
          console.log(response.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      active = false;
    };
  }, [user.username, language]);

  const cancelOrder = async (orderId) => {
    try {
      const authTokens = JSON.parse(localStorage.getItem("authTokens"));
      const response = await axios.post(
        `${API_URL}/inventory/order/details/cancel/`,
        {order_id: orderId,username: user.username},
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        }
      );
      if (response.status === 200) {
        setMessage({
          type: "success",
          text:
            language === "ar"
              ? t("orderList.cancelSuccess")
              : "Order cancelled successfully",
        });
        // Refresh the data
        const updatedData = data.filter(order => order.order_id !== orderId);
        setData(updatedData);
      }
    } catch (error) {
      const blocked = error.response?.status === 409;
      const blockedCode = error.response?.data?.code;
      setMessage({
        type: "danger",
        text:
          language === "ar"
            ? t(
                !blocked
                  ? "orderList.cancelFailed"
                  : blockedCode === "employee_required"
                    ? "orderList.cancelNeedsEmployee"
                    : blockedCode === "invoice_paid"
                      ? "orderList.cancelInvoicePaid"
                      : "orderList.cancelBlocked"
              )
            : (blocked && error.response?.data?.message) || "Failed to cancel order",
      });
      console.error(error);
    }
  };

  
  const getArabicOrderName = (row) => {
    if (
      row
      && typeof row.fullname_ar === "string"
      && row.fullname_ar.trim()
    ) {
      return row.fullname_ar.trim();
    }

    return row?.fullname_en || "";
  };

  const getSelectedArabicOrderName = () => {
    const selectedRow = data.find(
      (row) =>
        row.order_id === DealerDetails.order_id
    );

    return selectedRow
      ? getArabicOrderName(selectedRow)
      : DealerDetails.fullname_en;
  };

  const getArabicOrderStatus = (status) => {
    if (status === "Pending") {
      return t("orderList.pending");
    }

    if (status === "Confirmed") {
      return t("orderList.confirmed");
    }

    if (status === "Cancelled") {
      return t("orderList.cancelled");
    }

    return status;
  };

  const arabicGridLocaleText = {
    toolbarColumns:
      t("resellerOrders.columns"),

    toolbarFilters:
      t("resellerOrders.filters"),

    toolbarExport:
      t("resellerOrders.export"),

    toolbarExportCSV:
      t("resellerOrders.downloadCsv"),

    toolbarExportPrint:
      t("resellerOrders.print"),

    noRowsLabel:
      t("resellerOrders.noOrders"),

    noResultsOverlayLabel:
      t("resellerOrders.noResults"),

    footerRowSelected: (count) =>
      t(
        "resellerOrders.selectedRows",
        { count }
      ),

    MuiTablePagination: {
      labelRowsPerPage:
        t("resellerOrders.rowsPerPage"),

      labelDisplayedRows: ({
        from,
        to,
        count,
      }) =>
        t(
          "resellerOrders.pageRange",
          {
            from,
            to,
            count:
              count === -1
                ? `>${to}`
                : count,
          }
        ),
    },
  };

  const columns = [
    {
      field: "fullname_en",
      headerName:
        language === "ar"
          ? t("resellerOrders.name")
          : "Name",
      flex: 2,
      minWidth: 50,
      ...(language === "ar"
        ? {
            renderCell: (params) =>
              getArabicOrderName(params.row),
          }
        : {}),
    },
    {
      field: "date",
      headerName:
        language === "ar"
          ? t("resellerOrders.date")
          : "Date",
      flex: 2,
      minWidth: 200,
      type: "date", // Specify the type as 'date'
      valueGetter: (params) => new Date(params.value), // Ensure raw value is a Date object
      valueFormatter: (params) => formatDateTime(params.value),
      sortComparator: (v1, v2) => new Date(v1) - new Date(v2), // Custom sort comparator
    },
     {
       field: "status",
       headerName:
         language === "ar"
           ? t("orderList.status")
           : "Status",
       flex: 2,
       minWidth: 90,
       maxWidth: 100,
       ...(language === "ar"
         ? {
             renderCell: (params) =>
               getArabicOrderStatus(params.value),
           }
         : {}),
     },
     {
      field: "initiator",
      headerName:
        language === "ar"
          ? t("orderList.initiator")
          : "Initiator",
      flex: 2,
      minWidth: 50,
      maxWidth:70,
     },
    {
      field: "actions",
      headerName:
        language === "ar"
          ? t("resellerOrders.actions")
          : "Actions",
      minwidth: 700,
      flex: 2,
      renderCell: (params) => (
        <div>
          <button
            className="edit-client"
            onClick={() => {
              const details = {
                order_id: params.row.order_id,
                fullname_en: params.row.fullname_en,
              };
              updateDealerDetails(details);
              handleshowDetails();
            }}
          >
            {language === "ar" ? t("orderList.details") : "Details"}
          </button>
          <button
            className="edit-client"
            onClick={() => {
              const details = {
                order_id: params.row.order_id,
                fullname_en: params.row.fullname_en,
              };
              updateDealerDetails(details);
              handleshowQuotations();
            }}
          >
            {language === "ar" ? t("orderList.quotation") : "Quotation"}
          </button>
          <button
            className="edit-client"
            onClick={() => {
              const details = {
                order_id: params.row.order_id,
                fullname_en: params.row.fullname_en,
                client_id: params.row.client_id,
              };
              updateDealerDetails(details);
              handleshowInvoices();
            }}
          >
            {language === "ar" ? t("orderList.invoice") : "Invoice"}
          </button>
          <button
            className="edit-client"
            onClick={() => {
              const details = {
                order_id: params.row.order_id,
                fullname_en: params.row.fullname_en,
              };
              updateDealerDetails(details);
              issues(details);
            }}
          >
            {language === "ar" ? t("orderList.update") : "Update"}
          </button>
          <button
            className="edit-client"
            onClick={() => {
              setCancelOrderId(params.row.order_id);
            }}
          >
            {language === "ar" ? t("orderList.cancel") : "Cancel"}
          </button>
        </div>
      ),
    },
  ];

  const getRowId = (row) => row.order_id;
  
  useEffect(() => {
    // Save "searchValue" value before clearing other session storage items
    const searchValue = sessionStorage.getItem("searchOrder");
  
    // Clear all session storage items except "searchValue"
    Object.keys(sessionStorage).forEach((key) => {
      if (key !== "searchOrder") {
        sessionStorage.removeItem(key);
      }
    });
  
    // Restore "searchValue" value if needed
    if (searchValue) {
      sessionStorage.setItem("searchOrder", searchValue);
      setSearchQuery(searchValue)
    }
  }, []);
  
  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    sessionStorage.setItem("searchOrder", query);
  };

  const filteredRows = data.filter((row) => {
    const searchWords = searchQuery.split(" ");
    return searchWords.every((word) =>
      Object.values(row).some((value) =>
        String(value).toLowerCase().includes(word.toLowerCase().trim())
      )
    );
  });

  const CustomToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarExport />
    </GridToolbarContainer>
  );

  //Datatable HTML
  return (
    <div
      className="ClientTable accounting-order-table"
      dir={language === "ar" ? "rtl" : undefined}
    >
      <input
        type="text"
        placeholder={
          language === "ar"
            ? t("resellerOrders.searchPlaceholder")
            : "Search..."
        }
        value={searchQuery}
        onChange={handleSearch}
        className="search-client"
      />
      {!loading && data.length > 0 && (
        <div style={{ height: 520, width: "100%" }} className="table-container">
          <DataGrid
              localeText={
                language === "ar"
                  ? arabicGridLocaleText
                  : undefined
              }
              rows={filteredRows}
            columns={columns}
            getRowId={getRowId}
            components={{
              Toolbar: CustomToolbar,
            }}
            rowsPerPageOptions={[10, 100, 1000]}
            // Set the default page size to 10
            pagination
            disableSelectionOnClick
          />
        </div>
      )}
      <Modal
        show={showdetails}
        onHide={handlecloseDetails}
        className="modal-lg modal-responsive" dir={language === "ar" ? "rtl" : undefined}
      >
        <Modal.Header closeButton>
          <Modal.Title>
              {language === "ar"
                ? t("orderList.details")
                : "Details"}
            </Modal.Title>
        </Modal.Header>
        <EditOrder order_id={DealerDetails.order_id} />
      </Modal>
      <Modal
        show={showQuotation}
        onHide={handlecloseQuotations}
        className="modal-lg modal-responsive" dir={language === "ar" ? "rtl" : undefined}
      >
        <Modal.Header closeButton>
          <Modal.Title>
              {language === "ar"
                ? t("orderList.quotationFor", {
                    name:
                      getSelectedArabicOrderName(),
                  })
                : `Quotation for ${DealerDetails.fullname_en}`}
            </Modal.Title>
        </Modal.Header>
        <QuotationOrder order_id={DealerDetails.order_id} />
      </Modal>
      <Modal
        show={showInvoice}
        onHide={handlecloseInvoices}
        className="modal-lg modal-responsive" dir={language === "ar" ? "rtl" : undefined}
      >
        <Modal.Header closeButton>
          <Modal.Title>
              {language === "ar"
                ? t("orderList.invoiceFor", {
                    name:
                      getSelectedArabicOrderName(),
                  })
                : `Invoice for ${DealerDetails.fullname_en}`}
            </Modal.Title>
        </Modal.Header>
        <InvoiceOrder
          order_id={DealerDetails.order_id}
          client_id={DealerDetails.client_id}
        />
      </Modal>
        <Modal
          show={cancelOrderId !== null}
          className="order-cancel-confirm-modal"
          onHide={() => setCancelOrderId(null)}
          centered
          size="sm"
          dir={language === "ar" ? "rtl" : undefined}
        >
          <Modal.Body>
            {language === "ar"
              ? t("orderList.cancelConfirm")
              : "Are you sure you want to cancel this order?"}
          </Modal.Body>

          <Modal.Footer>
            <button
              className="edit-client"
              onClick={() => {
                const orderId = cancelOrderId;
                setCancelOrderId(null);

                if (orderId !== null) {
                  cancelOrder(orderId);
                }
              }}
            >
              {language === "ar" ? "نعم" : "Yes"}
            </button>

            <button
              className="edit-client"
              onClick={() => setCancelOrderId(null)}
            >
              {language === "ar" ? "لا" : "No"}
            </button>
          </Modal.Footer>
        </Modal>

      {message && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
          style={{
            position: "fixed",
            bottom: "10px",
            margin: "10px",
            right: "10px",
            zIndex: "9999",
          }}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}

export default OrderTable;

